export default __webpack_public_path__ + "static/media/array.1041c3f6.svg";